import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppControlTractor extends Layout {
    checkboxAddTrTlMessage: Checkbox;
    checkboxUpdateFuelLevel: Checkbox;
    checkboxUpdateOdometer: Checkbox;
    checkboxUseDashOdometerDelta: Checkbox;
    checkboxUsePositionOdometer: Checkbox;
    panelOne: Panel;
    panelTractorSection: Panel;
    panelTwo: Panel;
    sourceMCExAppControl: DataSource;
    textboxDeltaOdometer: Textbox;
    textboxFuelLevelField: Textbox;
    textboxOdometerField: Textbox;
    textboxTrTlMsg: Textbox;
    textboxTrTlMsgType: Textbox;
}
